// extracted by mini-css-extract-plugin
export default {"container":"CareRecipientNoList_container__EB7he","message":"CareRecipientNoList_message__zZfGu"};